// extracted by mini-css-extract-plugin
export default {"Layout_container":"Layout_Layout_container__gxbhZ","pageWrapper":"Layout_pageWrapper__aZNBt","mainContent":"Layout_mainContent__7DX+1","container":"Layout_container__xYvrL"};